import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Mail, Phone, ArrowRight } from 'lucide-react';
import { api } from '../context/AuthContext';
import { useLocalizedData } from '../i18n/dataLoader';

const Kontakt = ({ p }) => (
  <div className="flex items-center gap-4 mt-5 p-4 bg-[#f5f8fa] border-l-4 border-[#b8893d] text-left" data-testid="greeting-ansprechperson">
    <img src={p.image} alt={p.name} className="w-20 h-20 rounded-full object-cover border-2 border-[#b8893d] shrink-0" />
    <div className="min-w-0">
      <p className="font-serif text-lg text-[#1B3A5C] leading-tight" data-testid="greeting-ap-name">{p.name}{p.suffix ? ` ${p.suffix}` : ''}</p>
      <p className="text-xs text-[#34536b] mt-0.5">{p.role}</p>
      <a href={`mailto:${p.email}`} className="flex items-center gap-1.5 text-xs text-[#b8893d] mt-2 hover:underline truncate"><Mail className="w-3.5 h-3.5" />{p.email}</a>
      {p.phone && <a href={`tel:${p.phone.replace(/[^+\d]/g, '')}`} className="flex items-center gap-1.5 text-xs text-[#34536b] mt-1"><Phone className="w-3.5 h-3.5" />{p.phone}</a>}
    </div>
  </div>
);

export const WelcomeGreeting = ({ name, onContinue }) => {
  const { t } = useTranslation();
  const team = useLocalizedData('team')?.teamMembers || [];
  const [apEmail, setApEmail] = useState(undefined);
  useEffect(() => { api.get('/cases/meine-ansprechperson').then((r) => setApEmail(r.data.ansprechperson)).catch(() => setApEmail(null)); }, []);
  if (apEmail === undefined) return null;
  const p = team.find((m) => m.email === apEmail);
  return (
    <div className="fixed inset-0 z-[1000] bg-[#0f2740]/75 flex items-center justify-center p-4" data-testid="welcome-greeting">
      <div className="bg-white w-full max-w-md max-h-[92vh] overflow-y-auto rounded-sm shadow-2xl border-t-4 border-[#b8893d] p-7 animate-in fade-in zoom-in-95 duration-300">
        <img src="/assets/logo-gestapelt.png" alt="Kanzlei Nabhan Gäbler &amp; Partner" className="h-32 sm:h-40 w-auto mx-auto mb-6 select-none" draggable="false" data-testid="greeting-logo" />
        <p className="text-[10px] tracking-[0.3em] uppercase text-[#b8893d]">{t('greeting.kicker')}</p>
        <h2 className="font-serif text-3xl text-[#1B3A5C] mt-2" data-testid="greeting-title">{t('greeting.title', { name })}</h2>
        <p className="text-sm text-[#34536b] mt-3 leading-relaxed">{p ? t('greeting.body_ap') : t('greeting.body_team')}</p>
        {p && <><p className="text-[10px] tracking-[0.25em] uppercase text-[#7a8a99] mt-6">{t('greeting.ap_label')}</p><Kontakt p={p} /></>}
        <button type="button" onClick={onContinue} className="mt-7 w-full flex items-center justify-center gap-2 py-3 bg-[#1B3A5C] hover:bg-[#15304d] text-white text-xs tracking-[0.2em] uppercase rounded-sm transition-colors" data-testid="greeting-continue">
          {t('greeting.continue')} <ArrowRight className="w-4 h-4" />
        </button>
      </div>
    </div>
  );
};
